import { ApiUnreachableError, StampNotFoundError, fetchStampVerification } from "../../api";
import { EsploraClient } from "../../verify/esplora";
import { runPipeline } from "../../verify/pipeline";
import type { UiState } from "../render";

export interface VerifyViewDeps {
  stampSvcBase: string;
  esploraBaseUrls: string[];
}

export async function loadVerifyView(stampId: string, deps: VerifyViewDeps): Promise<UiState> {
  try {
    const apiResponse = await fetchStampVerification(deps.stampSvcBase, stampId);
    const esplora = new EsploraClient(deps.esploraBaseUrls);
    const result = await runPipeline(apiResponse, { esplora });
    const state: UiState = { kind: "verify-result", result };
    if (apiResponse.ots_state === "submitted" || apiResponse.ots_state === "confirmed") {
      state.download = {
        proofUrl: `${deps.stampSvcBase.replace(/\/$/, "")}/v/${stampId}/proof`,
      };
    }
    return state;
  } catch (e) {
    if (e instanceof StampNotFoundError) {
      return { kind: "stamp-not-found" };
    }
    if (e instanceof ApiUnreachableError) {
      return { kind: "stamp-svc-unreachable", reason: e.message };
    }
    return { kind: "stamp-svc-unreachable", reason: String(e) };
  }
}
